import { create } from 'apisauce'

const api = create({
    baseURL: 'https://vm1.tkgengates.com.br/'
})


api.addAsyncRequestTransform(response => async() =>{
    
    const token = localStorage.getItem('@USER_TOKEN')

    if(token){

        response.headers['Authorization']  = `Bearer ${token}`

    }

}) 

export default api